import { differentLocales } from '@abp/ng.core';
export function registerLocale(locale: string) {
  return import(
    /* @vite-ignore */
    /* webpackChunkName: "_locale-[request]"*/
    /* webpackInclude: /(en)\.mjs$/ */
    /* webpackExclude: /[/\\]global|extra/ */
    `../../node_modules/@angular/common/locales/${differentLocales[locale as keyof typeof differentLocales] || locale}.mjs`
  )
}
